
/**
 * Génère les initiales d'un utilisateur à partir de son prénom et de son nom
 * Utilise exactement la même logique que celle utilisée pour les marqueurs sur la carte
 * @param user Objet utilisateur contenant first_name, name et email
 * @returns Les initiales de l'utilisateur (2 caractères maximum)
 */
export const generateUserInitials = (user: {
  first_name?: string | null;
  name?: string | null;
  email?: string | null;
}): string => {
  // Créer les initiales à partir du prénom et du nom (même logique que dans useMarkers.ts)
  return user.first_name && user.name
    ? `${user.first_name[0]}${user.name[0]}`
    : user.email
      ? user.email[0].toUpperCase()
      : 'U';
};

